<template>
  <div class="pie-chart-container"></div>
</template>

<script>
import * as d3 from 'd3';

export default {
  props: ['entries', 'colors', 'radius', 'innerRadius', 'strokeWidth'],

  data() {
    return {
      width: this.radius * 2 || 110,
      height: this.radius * 2 || 110,
      negativeRadius: this.radius && this.innerRadius ? this.radius - this.innerRadius : 20,
    };
  },

  watch: {
    entries: {
      handler(val) {
        this.updatePie(val);
      },

      deep: true,
    },
  },

  mounted() {
    const { width, height, negativeRadius } = this;
    const radius = Math.min(width, height) / 2;

    var color = d3.scaleLinear().range(['#D60808', '#1DAEA1']);

    this.arc = d3
      .arc()
      .outerRadius(radius)
      .innerRadius(radius - negativeRadius);

    this.pie = d3
      .pie()
      .sort(null)
      .value(function (d) {
        return d.count;
      });

    this.svg = d3
      .select(this.$el)
      .append('svg')
      .attr('width', width)
      .attr('height', height)
      .attr('viewBox', `0 0 ${width} ${height}`)
      .append('g')
      .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

    const path = this.svg.datum(this.entries).selectAll('path').data(this.pie);

    path
      .enter()
      .append('path')
      .attr('fill', (d, i) => color(i))
      .attr('d', this.arc)
      .attr('stroke', 'white')
      .attr('stroke-width', this.strokeWidth || '3px')
      .each(function (d) {
        this._current = d;
      });
  },

  methods: {
    updatePie(data) {
      const { arc } = this;
      function arcTween(a) {
        const i = d3.interpolate(this._current, a);
        this._current = i(1);
        return t => arc(i(t));
      }
      const path = this.svg.datum(data).selectAll('path').data(this.pie);
      path.transition().duration(1000).attrTween('d', arcTween);
      path
        .enter()
        .append('path')
        .each(function (d) {
          this._current = d;
        });
    },
  },
};
</script>

<style lang="scss">
@use '@/styles/colors.scss';
.pie-chart-container {
  width: 100%;
  margin-top: 20px;
  svg {
    margin: auto;
    display: block;
  }
}
</style>
